import { Maybe } from '@iss/libs/graphql';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'imageUrl',
  standalone: true,
})
export class ImageUrlPipe implements PipeTransform {
  public transform(imageSrc: Maybe<string>, fallbackSrc?: Maybe<string>): string | undefined {
    const src = imageSrc || fallbackSrc;
    return src ? `url('${ src }')` : undefined;
  }
}
